module.exports = __webpack_public_path__ + "img/shareInfo2.3f1eee0e.png";